const toCsv = (rows) =>
  rows
    .map((cols) =>
      cols
        .map((c) => {
          const v = c === null || c === undefined ? "" : String(c);
          return `"${v.replace(/"/g, '""')}"`;
        })
        .join(";")
    )
    .join("\n");

export const downloadCsv = (filename, rows) => {
  // BOM para o Excel abrir acentuação corretamente
  const blob = new Blob(["﻿" + toCsv(rows)], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

// valor numérico no formato que o Excel pt-BR entende
export const csvNumber = (value) =>
  Number(value || 0)
    .toFixed(2)
    .replace(".", ",");
